import React, {useState, Fragment, useEffect} from 'react'
import {useDispatch, useSelector} from "react-redux"
import WebViewer from '@pdftron/webviewer'

// Material-UI Core
import {makeStyles} from '@material-ui/core/styles'
import Fab from '@material-ui/core/Fab'
import MenuItem from '@material-ui/core/MenuItem'
import TextField from '@material-ui/core/TextField'
import Typography from '@material-ui/core/Typography'
import Divider from '@material-ui/core/Divider'
import Box from '@material-ui/core/Box'
import Tooltip from '@material-ui/core/Tooltip'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemText from '@material-ui/core/ListItemText'
import ListItemAvatar from '@material-ui/core/ListItemAvatar'
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction'
import Avatar from '@material-ui/core/Avatar'

// Material-UI Icon
import DescriptionIcon from '@material-ui/icons/Description'

import DeleteIcon from '@material-ui/icons/Delete'
import GetAppIcon from '@material-ui/icons/GetApp'
import LaunchIcon from '@material-ui/icons/Launch'
import AddIcon from '@material-ui/icons/Add'

// Custom Component
import ConfirmDialog from '../Dialog/ConfirmDialog'

// Custom Style
import {fileZoneContentStyle} from '../../styles/jss/components/documentSubmission/fileZoneContentStyle'

// Global Function
import {webViewerLoadDocument} from "../../global/webViewerLoadDocument"
import {getAdministrableRight, getModifyRight} from '../../global/userRight'


// Fetch Data
import {fileDownload} from '../../dataSource/fileManager'


const useStyles = makeStyles(theme => fileZoneContentStyle(theme))

const FileZoneContent = props => {
	const store = require('store')
	const dispatch = useDispatch()

	const classes = useStyles()
	const {title, fileType, open, required, error, helperText} = props

	// Redux Data
	const submissionDetailRedux = useSelector(state => state.submissionDetailRedux)
	const modifySubmissionValueRedux = useSelector(state => state.modifySubmissionValueRedux)
	const userModulesRedux = useSelector(state => state.userModulesRedux)

	const [administrableRight, setAdministrableRight] = useState(false)
	const [modifyRight, setModifyRight] = useState(false)

	const [submissionProperty, setSubmissionProperty] = useState(null)
	const [confirmDialogOpen, setConfirmDialogOpen] = useState(false)
	const [confirmDialogData, setConfirmDialogData] = useState({
		dialogTitle: "",
		dialogContent: "",
		confirmAction: "",
		cancelAction: ""
	})


	// Handle Form Input
	const handleChange = index => event => {
		const {name, value} = event.target
		const res = {...submissionProperty.files}

		res[fileType][index][name] = value

		setSubmissionProperty({...submissionProperty, files: res})
		dispatch({
			type: "MODIFY_SUBMISSION_VALUE",
			data: {...submissionProperty, files: res}
		})
	}


	// Build Confirm Dialog
	const confirmDialogHandleOpen = (data) => {
		setConfirmDialogData({
			dialogTitle: data.dialogTitle,
			dialogContent: data.dialogContent,
			confirmAction: data.confirmAction,
			cancelAction: data.cancelAction
		})

		setConfirmDialogOpen(true)
	}

	const confirmDialogHandleClose = () => {
		setConfirmDialogOpen(false)
	}


	// Main Action
	const removeFileConfirmAction = (fileElementName, fileSeq) => {
		confirmDialogHandleOpen({
			dialogTitle: "Document Submission file remove",
			dialogContent: "Do you want to remove the file.",
			confirmAction: () => removeFileAction(fileElementName, fileSeq),
			cancelAction: removeFileCancelAction
		})
	}

	const removeFileCancelAction = () => {
		confirmDialogHandleClose()
	}

	const removeFileAction = (fileElementName, fileSeq) => {
		confirmDialogHandleClose()
		const val = {...submissionProperty.files}

		val[fileElementName].map((res, index) => {
			if (res.file_seq === fileSeq) {
				val[fileElementName].splice(index, 1)

				setSubmissionProperty({...submissionProperty, files: val})
				dispatch({
					type: "MODIFY_SUBMISSION_VALUE",
					data: {...submissionProperty, files: val}
				})

				console.log("*****************************************************************************")
				console.log("System Module: Document Submission")
				console.log("Message: File remove successful.")
				console.log(res)
				console.log("*****************************************************************************")
			}
		})
	}

	const downloadFileAction = (fileCat, fileSeq) => {
		fileDownload(fileCat, fileSeq).then(res => {
			console.log("*****************************************************************************")
			console.log("System Module: Document Submission")
			console.log("Message: File download successful.")
			console.log("*****************************************************************************")
		})
	}

	const previewFileAction = (fileCat, fileSeq, filename) => {
		let instance = WebViewer.getInstance(document.getElementById('webviewer'))

		webViewerLoadDocument("workflow", fileCat, null, fileSeq, filename)

		// console.log("File categary")
		// console.log(fileCat)
		// console.log("File seq")
		// console.log(fileSeq)

		// instance.loadDocument(`http://172.16.145.30:3002/api/v1/file/download?file_cat=${fileCat}&file_seq=${fileSeq}`, {
		// 	customHeaders: {
		// 		"Authorization": "Bearer " + store.get('access_token'),
		// 		"site": store.get('site'),
		// 		"locale": store.get('locale')
		// 	}
		// })
	}

	
	useEffect(() => {
		getAdministrableRight(userModulesRedux, "/submission").then(res => {
			setAdministrableRight(res)
		})

		getModifyRight(userModulesRedux, "/submission").then(res => {
			setModifyRight(res)
		})
	})

	useEffect(() => {
		setSubmissionProperty(modifySubmissionValueRedux)
	})


	return (
		// console.log("Document Submission Detail Data (Redux) | Variable: submissionDetailRedux (FileZoneContent.js)"),
		// console.log(submissionDetailRedux),

		// console.log("Document Submission Value (Redux) | Variable: modifySubmissionValueRedux (FileZoneContent.js)"),
		// console.log(modifySubmissionValueRedux),

		// console.log("Submission Property | Variable: submissionProperty (FileZoneContent.js)"),
		// console.log(submissionProperty),

		// console.log("---------------------------------------------------------------------------------"),
		

		<Fragment>
			<ConfirmDialog
				open={confirmDialogOpen}
				dialogTitle={confirmDialogData.dialogTitle}
				dialogContent={confirmDialogData.dialogContent}
				confirmAction={confirmDialogData.confirmAction}
				cancelAction={confirmDialogData.cancelAction}
			/>

			{/* <Box border={1} borderRadius="borderRadius" borderColor="grey.400" className={classes.fileList}>
				<Typography variant="button">{title}</Typography> */}

			<Box border={1} borderRadius="borderRadius" borderColor={required ? error ? "error.main" : "grey.400" : "grey.400"} className={classes.fileList}>
				<Typography variant="button" color={required ? error ? "error" : "textPrimary" : "textPrimary"}>{title}</Typography>

				<List>
				{
					submissionDetailRedux !== null ?
					
						Array.isArray(submissionDetailRedux.files[fileType]) ?
							submissionDetailRedux.files[fileType].map((res, index) => {
								return (
									<div key={index}>
										<ListItem>
											<ListItemAvatar>
												<Avatar>
													<DescriptionIcon />
												</Avatar>
											</ListItemAvatar>
											<ListItemText primary={res.filename} secondary={"Last updated: " + res.modifydate} />

											<ListItemSecondaryAction>
												<Tooltip title="View File">
													<Fab color="primary" size="small" aria-label="view" className={classes.attachmentBtn} onClick={() => previewFileAction("master", res.file_seq, res.filename)}>
														<LaunchIcon />
													</Fab>
												</Tooltip>

												<Tooltip title="Download File">
													<Fab color="primary" size="small" aria-label="download" className={classes.attachmentBtn} onClick={() => downloadFileAction("master", res.file_seq)}>
														<GetAppIcon />
													</Fab>
												</Tooltip>

												{
													modifyRight ?
														submissionDetailRedux.options.updatable ?
															<Tooltip title="Remove File">
																<Fab color="primary" size="small" aria-label="delete" className={classes.attachmentBtn} onClick={() => removeFileConfirmAction(fileType, res.file_seq)}>
																	<DeleteIcon />
																</Fab>
															</Tooltip>
														: ""
													: ""
												}
											</ListItemSecondaryAction>
										</ListItem>

										{/* {
											administrableRight ?
												submissionDetailRedux.options.approvable ?
													<div className={classes.approveText}>
														<TextField
															select
															required
															key={"confidential_" + res.file_seq + "_" + index}
															id={"confidential_" + res.file_seq + "_" + index}
															name={"is_confidential"}
															label="File Confidential"
															fullWidth={true}
															size="small"
															variant="outlined"
															value={submissionProperty !== null ? submissionProperty.files[fileType][index].is_confidential : ""}
															onChange={handleChange(index)}
															InputProps={{
																readOnly: false,
															}}
														>
															<MenuItem key={true} value={true}>YES</MenuItem>
															<MenuItem key={false} value={false}>NO</MenuItem>
														</TextField>

														<TextField
															key={"ref_cover_no_" + res.file_seq + "_" + index}
															id={"ref_cover_no_" + res.file_seq + "_" + index}
															name={"ref_cover_no"}
															label={"File Reference No."}
															type="text"
															fullWidth={true}
															size="small"
															variant="outlined"
															value={submissionProperty !== null ? submissionProperty.files[fileType][index].ref_cover_no : ""}
															onChange={handleChange(index)}
															InputProps={{
																readOnly: false,
															}}
														/>

														<TextField
															key={"file_subject_" + res.file_seq + "_" + index}
															id={"file_subject_" + res.file_seq + "_" + index}
															name={"file_subject"}
															label={"File Subject"}
															type="text"
															fullWidth={true}
															size="small"
															variant="outlined"
															value={submissionProperty !== null ? submissionProperty.files[fileType][index].file_subject : ""}
															onChange={handleChange(index)}
															InputProps={{
																readOnly: false,
															}}
														/>

														<TextField
															key={"remark_" + res.file_seq + "_" + index}
															id={"remark_" + res.file_seq + "_" + index}
															name={"remark"}
															label={"Remark"}
															type="text"
															fullWidth={true}
															size="small"
															variant="outlined"
															value={submissionProperty !== null ? submissionProperty.files[fileType][index].remark : ""}
															onChange={handleChange(index)}
															InputProps={{
																readOnly: false,
															}}
														/>
													</div>
												:
													<div className={classes.approveText}>
														<TextField
															select
															required
															key={"confidential_" + res.file_seq + "_" + index}
															id={"confidential_" + res.file_seq + "_" + index}
															name={"is_confidential"}
															label="File Confidential"
															fullWidth={true}
															size="small"
															variant="outlined"
															value={submissionProperty !== null ? submissionProperty.files[fileType][index].is_confidential : ""}
															onChange={handleChange(index)}
															InputProps={{
																readOnly: true,
															}}
														>
															<MenuItem key={true} value={true}>YES</MenuItem>
															<MenuItem key={false} value={false}>NO</MenuItem>
														</TextField>

														<TextField
															key={"ref_cover_no_" + res.file_seq + "_" + index}
															id={"ref_cover_no_" + res.file_seq + "_" + index}
															name={"ref_cover_no"}
															label={"File Reference No."}
															type="text"
															fullWidth={true}
															size="small"
															variant="outlined"
															value={submissionProperty !== null ? submissionProperty.files[fileType][index].ref_cover_no : ""}
															onChange={handleChange(index)}
															InputProps={{
																readOnly: true,
															}}
														/>

														<TextField
															key={"file_subject_" + res.file_seq + "_" + index}
															id={"file_subject_" + res.file_seq + "_" + index}
															name={"file_subject"}
															label={"File Subject"}
															type="text"
															fullWidth={true}
															size="small"
															variant="outlined"
															value={submissionProperty !== null ? submissionProperty.files[fileType][index].file_subject : ""}
															onChange={handleChange(index)}
															InputProps={{
																readOnly: true,
															}}
														/>

														<TextField
															key={"remark_" + res.file_seq + "_" + index}
															id={"remark_" + res.file_seq + "_" + index}
															name={"remark"}
															label={"Remark"}
															type="text"
															fullWidth={true}
															size="small"
															variant="outlined"
															value={submissionProperty !== null ? submissionProperty.files[fileType][index].remark : ""}
															onChange={handleChange(index)}
															InputProps={{
																readOnly: true,
															}}
														/>
													</div>
												
											: ""
										} */}

										<Divider className={classes.approveTextDivider} />
									</div>
								)
							})
						: ""
					: ""
				}
				</List>

				{
					modifyRight ?
						submissionDetailRedux !== null ?
							submissionDetailRedux.options.updatable ?
								<Box className={classes.fileUploadBtnArea}>
									<Tooltip title="Choose File">
										<Fab color="primary" size="small" aria-label="upload_file" className={classes.fileUploadBtn} onClick={open}>
											<AddIcon />
										</Fab>
									</Tooltip>
								</Box>
							: ""
						: ""
					: ""
				}
			</Box>
			{
				required ? 
					error ?	<Typography variant="caption" color="error" className={classes.uploadErrorMsg}>{helperText}</Typography> : "" 
				: ""
			}
			
		</Fragment>
	)
}

export default FileZoneContent